import { render, staticRenderFns } from "./productPic.vue?vue&type=template&id=7c4b7d1c&scoped=true"
import script from "./productPic.vue?vue&type=script&lang=js"
export * from "./productPic.vue?vue&type=script&lang=js"
import style0 from "./productPic.vue?vue&type=style&index=0&id=7c4b7d1c&prod&lang=scss&scoped=true"
import style1 from "./productPic.vue?vue&type=style&index=1&id=7c4b7d1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4b7d1c",
  null
  
)

export default component.exports